<template>

    <div class="modal attendance-modal fade" id="addUsersToConversationModal" tabindex="-1" aria-labelledby="addUsersToConversationModal" aria-hidden="true" style="z-index:99999;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Gebruikers toevoegen</p>
                    </div>
                    <button type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body pt-3 pb-4 px-4">
                    <div class="employees-list" v-if="this.users !== null">
                        <label class="employee" v-for="user in users" :for="user.id" role="button">
                            <div class="message-content">
                                <div class="name text-sm fw-semibold" :class="{ 'is-locked': isLocked(user) }">
                                    <input
                                        v-model="user.is_linked"
                                        type="checkbox"
                                        v-bind:id="user.id"
                                        :class="{ 'locked-checkbox': isLocked(user) }"
                                        :disabled="isLocked(user)">
                                    <div>
                                        {{ user.name }}<span v-if="user.id === currentUserId" class="text-muted"> (jij)</span>
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="modal-body pt-3 pb-4 px-4 d-flex">
                    <button class="btn btn-primary ms-auto px-3 py-2 text-sm" @click="saveUsers()">Opslaan</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'add-users-to-conversation-modal',
    data() {
        return {
            users: [],
            conversationId: null,
            currentUserId: null
        }
    },
    methods: {
        isLocked(user) {
            // A participant can only remove themselves; everyone else's checkbox is locked.
            return user.already_linked && user.id !== this.currentUserId;
        },
        isCurrentUserLeaving() {
            const currentUser = this.users.find(user => user.id === this.currentUserId);
            return !!(currentUser && currentUser.already_linked && !currentUser.is_linked);
        },
        persist() {
            const leaving = this.isCurrentUserLeaving();

            axios.post('api/save-users-to-conversation', {
                users: this.users,
                conversationId: this.conversationId
            })
            .then(response => {
                if (response.data.status === 422) {
                    this.modal.hide();
                    throw [true, response.data.message];
                }

                this.modal.hide();

                if (leaving) {
                    EventBus.$emit('conversationLeft', this.conversationId);
                    this.$swal("Succes", "Je hebt het gesprek verlaten.", "success");
                } else {
                    EventBus.$emit('refetchConversations');
                    this.$swal("Succes", "De wijzigingen zijn opgeslagen.", "success");
                }
            })
            .catch(e => {
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
            });
        },
        saveUsers() {
            if (this.isCurrentUserLeaving()) {
                this.$swal({
                    title: "Gesprek verlaten?",
                    text: "Je wordt verwijderd als deelnemer. Andere deelnemers kunnen je later weer toevoegen.",
                    showCancelButton: true,
                    cancelButtonColor: "#3EBE00",
                    confirmButtonColor: "#DD3444",
                    confirmButtonText: "Ja, verlaten",
                    cancelButtonText: "Annuleren",
                }).then((callBack) => {
                    if (callBack.isConfirmed) {
                        this.persist();
                    }
                });

                return;
            }

            this.persist();
        },
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('addUsersToConversationModal'));

        EventBus.$on('addUsersToConversation', (data) => {
            this.users = data.users.map(user => ({
                ...user,
                already_linked: user.is_linked
            }));
            this.conversationId = data.conversationId;
            this.currentUserId = data.currentUserId;

            this.modal.show();
        });
    },
}
</script>

<style scoped>
/* The grey checkbox colour for locked participants lives in the global SCSS
   (.employees-list .employee .name input.locked-checkbox) because the checkbox
   uses appearance:none custom styling that ignores accent-color. */
.name.is-locked > div {
    color: #9aa0a6;
    font-style: italic;
}
</style>
